<template>
  <v-app>
    <v-navigation-drawer
      app
      clipped
      v-model="$store.state.menu_visible">
      <v-list>

        <template v-for="(item, i) in items" >
          <v-list-item :key="i" :to="item.link" active-class="primary--text">
            <v-list-item-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{item.title}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider :key ="item.link" v-if="item.divider"></v-divider>
        </template>

        <v-divider></v-divider>

        <v-list-item value="true" @click.stop="logout()"  active-class="secondary--text">
          <v-list-item-action>
            <v-icon light v-html="'exit_to_app'"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="'Logout'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar fixed clipped-left app >
      <v-toolbar-title>
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="SHOW_MENU"></v-app-bar-nav-icon>
        <span v-if="stage !== 'prod'" :class="stageToClass[stage]">[{{stage}}]</span>
        <img :src="logo" :class="$style.logo"/> ISRS Backoffice
      </v-toolbar-title>
    </v-app-bar>

    <v-main>
      <!--<isrs-breadcrumb :breadcrumbs="$store.state.breadcrumbs"></isrs-breadcrumb>-->

      <router-view v-if="complete"></router-view>
      <v-progress-linear v-bind:indeterminate="true" v-else></v-progress-linear>
    </v-main>

  </v-app>
</template>

<style module>
.logo {
  height: 22px;
  transform: translateY(1px);
}
</style>

<script>
import AWS from 'aws-sdk'
import Vue from 'vue'
import DataService from '../services/data'
import AuthService from '../services/auth'
import IsrsBreadcrumb from '../components/IsrsBreadcrumb.vue'
import glsLogo from '../../static/gls_logo.png'

import { mapMutations } from 'vuex'

export default {
  components: { IsrsBreadcrumb },

  data() {
    return {
      logo: glsLogo,
      complete: false,
      items: [
        {
          icon: 'home',
          title: 'Dashboard',
          link: '/',
          divider: true
        },
        {
          icon: 'shopping_basket',
          title: 'Portals',
          link: '/returnshopportals'
        },
        {
          icon: 'keyboard_return',
          title: 'Returns',
          link: '/returns'
        },
        {
          icon: 'dns',
          title: 'Parcel Number Container',
          link: '/parcelnumbercontainers',
          divider: true
        },
        {
          icon: 'contacts',
          title: 'Contacts',
          link: '/contacts'
        },
        {
          icon: 'domain',
          title: 'Customer',
          link: '/customers'
        },
        {
          title: 'Locations',
          link: '/locations',
          icon: 'location_on'
        },
        {
          title: 'Countries',
          link: '/countries',
          icon: 'flag'
        },
        {
          title: 'Owner',
          link: '/owners',
          icon: 'person_pin',
          divider: true
        },
        {
          icon: 'import_export',
          title: 'Import',
          link: '/import'
        },
        {
          icon: 'create',
          title: 'Create',
          link: '/create'
        }
      ],
      stage: profileConfig.meta.stage,
      stageToClass: {
        local: 'deep-orange--text text--darken-3',
        dev: 'indigo--text text--darken-4',
        stage: 'green--text text--darken-4'
      }
    }
  },

  created() {
    this.complete = false

    const stage = profileConfig.meta.stage
    if (stage !== 'prod') {
      document.title = `[${stage}] ${document.title}`
    }

    return this.loadSession()
      .then(() => {
        return this.checkCurrentSession()
      })
      .then(() => {
        if (this.$route.name === 'login') {
          this.$router.push('/dashboard')
        }

        this.$store.commit('SHOW_MENU', true)

        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: profileConfig.auth.identityPoolId,
          //IdentityId: AWS.config.credentials.identityId,
          Logins: {
            [`cognito-idp.eu-central-1.amazonaws.com/${
              profileConfig.auth.userPoolId
            }`]: this.$store.state.tokens.idToken
          }
        })

        Vue.prototype.dataService = new DataService(
          this.profile,
          this.$store.state.tokens
        )

        return AWS.config.credentials.getPromise()
          .then(() => {
            // now I'm using authenticated credentials
            this.updateUiFromRouter(this.$route)

            this.$router.beforeEach((to, from, next) => {
              console.info('before route enter [APP]')

              // check login token expire time
              this.checkCurrentSession()
                .then(() => {
                  this.updateUiFromRouter(to)
                  next()
                })
                .catch(err => {
                  console.error('session invalid, load /login', err)
                  location.reload()
                })
            })

            // load countries
            this.$store.dispatch('config/fetchIsrsConfig').then(() => {
              console.info('Done')
            })

            this.complete = true
          }).catch(err => {
            console.error('error in authentication: ', err)
            AuthService.logoutUser().then(() => {
              location.reload()
            })
          })
      })
      .catch(err => {
        this.complete = true
        console.error('session invalid, load /login', err)
      })
  },

  mounted() {

  },

  methods: {
    ...mapMutations(['SHOW_MENU']),
    logout() {
      AuthService.logoutUser().then(() => {
        location.reload()
      })
      // reload app to clear vuex cache etc
    },

    loadSession() {
      //Get the accessToken from the federatedSignIn callback Url
      this.$store.state.currentUrl = this.$route

      //Store the token
      let federatedAuthTokens = this.getTokensFromFederatedAuth()

      for (let i = 0; i < federatedAuthTokens.length; i++) {
        let entity = federatedAuthTokens[i].split('=')
        switch (entity[0]) {
          case 'access_token':
            this.$store.state.token = {
              access_token: entity[1],
            }
            break
          case 'id_token':
            this.$store.state.token.id_token = entity[1]
            break
          case 'state':
            this.$store.state.token.state = entity[1]
            break
          case 'token_type':
            this.$store.state.token.token_type = entity[1]
            break
          case 'expires_in':
            this.$store.state.token.expires_in = entity[1]
            break
          default:
            console.log(`NO TOKEN ${entity}.`)
        }
      }

      return AuthService.isValidSession()
        .then(() => {
          console.log('IS VALID SESSION (APP)')
          this.storeSession(this.$store.state.token)
          return cognitoUser
        })
        .then(AuthService.getUserAttributes)
        .then((userAttributes) => {
          this.$store.commit('SET_USER', userAttributes)
        })
        .catch(() => {
          if (this.$route.name !== 'login') {
            this.$router.push('/login')
          }
        })
    },

    getTokensFromFederatedAuth() {
      let currentUrl = this.$store.state.currentUrl
      var query = currentUrl.fullPath.substring(1)
      var vars = query.split('&')
      return vars
    },

    storeSession(session) {
      const idToken = session.id_token
      const idTokenExpires = session.expires_in
      const accessToken = session.access_token
      const accessTokenExpires = session.expires_in

      this.$store.commit('SET_TOKENS', {
        idToken,
        accessToken,
        expires: {
          idToken: idTokenExpires,
          accessToken: accessTokenExpires
        }
      })

      AWS.config.region = 'eu-central-1'
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: profileConfig.auth.identityPoolId,
        Logins: {
          [`cognito-idp.eu-central-1.amazonaws.com/${
            profileConfig.auth.userPoolId
          }`]: idToken
        }
      })
    },

    checkCurrentSession() {
      return new Promise((resolve, reject) => {
        if (
          this.$store &&
          this.$store.state &&
          this.$store.state.tokens &&
          this.$store.state.tokens.expires
        ) {
          const accessTokenExpires = this.$store.state.tokens.expires
            .accessToken
          const idTokenExpires = this.$store.state.tokens.expires.idToken

          // refresh session 30 minutes before it will be invalid
          const refreshAccessTokenUntil = accessTokenExpires - 1800
          const refreshIdTokenUntil = idTokenExpires - 1800
          const now = Date.now() / 1000

          if (refreshAccessTokenUntil < now || refreshIdTokenUntil < now) {
            console.warn('SESSION TIMED OUT')
            AWS.config.credentials.refresh(error => {
              if (error) {
                console.error('unable to refresh session')
                reject()
              } else {
                console.info('session refreshed!')
                resolve()
              }
            })
          } else {
            resolve()
          }
        } else {
          reject()
        }
      })
    },

    updateUiFromRouter(toRoute) {
      // check meta information
      // - build sidebar
      let sidebar = []
      if (toRoute.matched) {
        toRoute.matched.forEach(route => {
          if (route.meta && route.meta.sidebar) {
            sidebar = sidebar.concat(route.meta.sidebar)
          }
        })

        this.$store.commit('SET_SIDEBAR', sidebar)
      }
      // - build breadcrumbs
      let breadcrumbs = []
      if (toRoute.matched) {
        toRoute.matched.forEach(route => {
          if (route.meta && route.meta.breadcrumbs) {
            breadcrumbs = breadcrumbs.concat(route.meta.breadcrumbs)
          }
        })

        this.$store.commit('SET_BREADCRUMBS', breadcrumbs)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?087c7b57